module.exports = __webpack_public_path__ + "img/tarde_c1@2x.439aa611.png";